import { useMemo } from 'react';

import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { useLocale } from '@atlassian/jira-tenant-context-controller/src/components/locale/index.tsx';
import { useUserFullname } from '@atlassian/jira-tenant-context-controller/src/components/user-fullname/index.tsx';
import type { AtlassianUser } from '@atlassian/viz-platform-views/types/common/types/src/users';

export function useAvpAtlassianUser(): AtlassianUser {
	const accountId = useAccountId();
	const userFullname = useUserFullname();
	const locale = useLocale();

	return useMemo(
		() =>
			// TODO: `AtlassianUser` requires fields we do not obtain synchronously (i.e. picture).
			// oxlint-disable-next-line typescript/consistent-type-assertions -- partial tenant user asserted to viz contract
			({
				account_id: accountId,
				name: userFullname,
				picture: undefined,
				principal_type: 'user',
				locale,
				email: undefined,
			}) as unknown as AtlassianUser,
		[accountId, userFullname, locale],
	);
}
